import React, { FC, useEffect, useState } from "react";
import Input from "../customhtmlcomponents/Input";
import Button from "../customhtmlcomponents/Button";
import { useForm } from "react-hook-form";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import { useLocation } from "react-router";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import { useHistory } from "react-router-dom";
import { ResponseData } from "../adminpanel/panels/types/types";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";
import { IntlNubmerFormatter } from "../../utility/formatInputField";
import getRapportAar from "../../utility/dateUtils";

export interface IStyretProps {
  setCurrentForeningReportNumber: React.Dispatch<React.SetStateAction<number>>;
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type State = {
  foreningsNummer: number;
  lederNavn: string;
  lederMedlemNummer: number;
  lederTelefon: number;
  lederEpost: string;
  nestlederNavn: string;
  nestlederMedlemNummer: number;
  nestlederTelefon: number;
  nestlederEpost: string;
  kassererNavn: string;
  kassererMedlemNummer: number;
  kassererTelefon: number;
  kassererEpost: string;
};

type LastYearStyret = {
  ar: number;
  lederNavn: string;
  lederMedlemNummer: string;
  lederTelefon: string;
  lederEpost: string;
  nestlederNavn: string;
  nestlederMedlemNummer: string;
  nestlederTelefon: string;
  nestlederEpost: string;
  kassererNavn: string;
  kassererMedlemNummer: string;
  kassererTelefon: string;
  kassererEpost: string;
};

const Styret: FC<IStyretProps> = ({
  currentForeningReportNumber,
  message,
  username,
  setModal,
  setCurrentForeningReportNumber,
}: IStyretProps) => {
  const { register, setValue, handleSubmit, errors, getValues } =
    useForm<State>();
  const [lastYearStyre, setLastYearStyre] = useState<LastYearStyret>({
    ar: 0,
    lederNavn: "",
    lederMedlemNummer: "",
    lederTelefon: "",
    lederEpost: "",
    nestlederNavn: "",
    nestlederMedlemNummer: "",
    nestlederTelefon: "",
    nestlederEpost: "",
    kassererNavn: "",
    kassererMedlemNummer: "",
    kassererTelefon: "",
    kassererEpost: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ar, setAr] = useState(getRapportAar);
  const getLastYear = () => {
    setValue("lederNavn", lastYearStyre.lederNavn);
    setValue("lederEpost", lastYearStyre.lederEpost);
    setValue("lederMedlemNummer", lastYearStyre.lederMedlemNummer);
    setValue("lederTelefon", lastYearStyre.lederTelefon);
    setValue("nestlederNavn", lastYearStyre.nestlederNavn);
    setValue("nestlederEpost", lastYearStyre.nestlederEpost);
    setValue("nestlederTelefon", lastYearStyre.nestlederTelefon);
    setValue("nestlederMedlemNummer", lastYearStyre.nestlederMedlemNummer);
    setValue("kassererNavn", lastYearStyre.kassererNavn);
    setValue("kassererEpost", lastYearStyre.kassererEpost);
    setValue("kassererTelefon", lastYearStyre.kassererTelefon);
    setValue("kassererMedlemNummer", lastYearStyre.kassererMedlemNummer);
  };
  const history = useHistory();
  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    e.preventDefault();
    handleNavBarClick().then(() => history.push(link));
  };
  const handleNavBarClick = handleSubmit<State>(async (getValues) => {
    postFormData(getValues, false);
  });

  const postFormData = async (getValues: any, redirectToNextPage: boolean) => {
    setIsSubmitting(true);
    const values = {
      ...getValues,
      foreningsNummer: currentForeningReportNumber,
    };
    axios
      .post(URLS.STYRET_POST, values)
      .then((response: AxiosResponse) => {
        console.log(response.data);
        console.log(typeof message);

        saveSuccessMessage();

        if(redirectToNextPage){
          setTimeout(
            () =>
              {
                setIsSubmitting(false)
                history.push({
                pathname: "/eiendom",
                state: currentForeningReportNumber,
                })
              },
            1750
          );
        }
      })
      .catch((error) => {
        console.log(error?.response?.data);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av Styret. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false)
          setIsSubmitting(false)
        }, 5000);
      });
  }

  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Styret ble lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 2000);
  };
  const submitStyret = handleSubmit((getValues) => {
    postFormData(getValues, true);
  });
  const location = useLocation();

  useEffect(() => {
    setValue("foreningsNummer", currentForeningReportNumber);

    async function getStyret() {
      const response = await axios.get(
        `${URLS.STYRET_GET}${currentForeningReportNumber}`,
        {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        }
      );
      setValue("lederNavn", response.data.lederNavn);
      setValue("lederMedlemNummer", response.data.lederMedlemNummer);
      setValue("lederTelefon", response.data.lederTelefon);
      setValue("lederEpost", response.data.lederEpost);
      setValue("nestlederNavn", response.data.nestlederNavn);
      setValue("nestlederMedlemNummer", response.data.nestlederMedlemNummer);
      setValue("nestlederTelefon", response.data.nestlederTelefon);
      setValue("nestlederEpost", response.data.nestlederEpost);
      setValue("kassererNavn", response.data.kassererNavn);
      setValue("kassererMedlemNummer", response.data.kassererMedlemNummer);
      setValue("kassererTelefon", response.data.kassererTelefon);
      setValue("kassererEpost", response.data.kassererEpost);
    }

    async function getLastYearStyret() {
      await axios
        .get(
          `${URLS.STYRET_GET}${currentForeningReportNumber}/${
            getRapportAar - 1
          }`,
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        )
        .then((response: AxiosResponse<LastYearStyret>) => {
          console.log(response);
          setLastYearStyre({
            ar: response.data.ar,
            lederNavn: response.data.lederNavn,
            lederMedlemNummer: response.data.lederMedlemNummer,
            lederTelefon: response.data.lederTelefon,
            lederEpost: response.data.lederEpost,
            nestlederNavn: response.data.nestlederNavn,
            nestlederMedlemNummer: response.data.nestlederMedlemNummer,
            nestlederTelefon: response.data.nestlederTelefon,
            nestlederEpost: response.data.nestlederEpost,
            kassererNavn: response.data.kassererNavn,
            kassererEpost: response.data.kassererEpost,
            kassererMedlemNummer: response.data.kassererMedlemNummer,
            kassererTelefon: response.data.kassererTelefon,
          });
        });
    }

    getStyret().then(() => console.log(getValues()));
    getLastYearStyret().then(() => console.log(lastYearStyre));
  }, [isLoading, currentForeningReportNumber, location.state]);
  const lastYear =
    lastYearStyre.ar === 0 ? getRapportAar - 1 : lastYearStyre.ar;
  const year = ar === 0 ? getRapportAar : ar;

  return (
    <div className="">
      <NavigationBar saveOnClick={saveOnClick} />
      <form onSubmit={submitStyret}>
        <div>
          <p className="text-black text-center text-2xl font-bold mt-2py-2 p">
            2. Styret og informasjon om foreningen{" "}
          </p>
        </div>
        {/*Table one starts here*/}
        <div className="flex flex-grow-0 flex-row m-auto justify-center transform scale-75 md:scale-75">
          <div className=" mt-4 h-2/3 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl">
            <p className="text-black text-center text-2xl font-bold mt-4 py-2">
              {`2.1 Styret forrige år (${lastYear})`}
            </p>

            <table className="table-auto mt-4 self-center justify-center justify-items-center text-center">
              <thead>
                <tr className="border-b border-sk-tertiary-blue text-center">
                  <th className="w-1/12 text-xl font-medium">År</th>
                  <th className="w-1/12 text-xl font-thin ">Posisjon</th>
                  <th className="w-1/4 text-xl font-thin ">Medlemsnr</th>
                  <th className="w-1/4 text-xl font-thin">Navn</th>
                  <th className="w-1/4 text-xl font-thin ">Telefon</th>
                  <th className="w-1/4 text-xl font-thin">Epost</th>
                </tr>
                <tr>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYear}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>Leder</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.lederMedlemNummer}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.lederNavn}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.lederTelefon}</p>
                  </td>
                  <td className="border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.lederEpost}</p>
                  </td>
                </tr>
                <tr>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYear}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>NestLeder</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.nestlederMedlemNummer}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.nestlederNavn}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.nestlederTelefon}</p>
                  </td>
                  <td className="border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.nestlederEpost}</p>
                  </td>
                </tr>
                <tr>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYear}</p>
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>Kasserer</p>
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.kassererMedlemNummer}</p>
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.kassererNavn}</p>
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.kassererTelefon}</p>
                  </td>
                  <td className="border-sk-tertiary-blue p-5 text-xl">
                    <p>{lastYearStyre.kassererEpost}</p>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        {/*Table two starts here*/}
        <div className="  flex flex-grow-0 flex-row m-auto justify-center transform scale-75 md:scale-75">
          <div className=" mt-4  self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl">
            <div>
              <p className="text-black text-center text-2xl font-bold mt-4 py-2">
                {`2.2 Styret i år (${year})`}</p>
              <div className="flex justify-center">
                <Button type="button" onClick={getLastYear}>
                  Kopier fra forrige år
                </Button>
              </div>
            </div>
            <table className="mt-4 table-auto self-center justify-center justify-items-center text-center">
              <thead>
                <tr className="border-b border-sk-tertiary-blue">
                  <th className=" w-1/12 text-xl font-thin">År</th>
                  <th className=" w-1/12 text-xl font-thin">Posisjon</th>
                  <th className="lg:w-5/12	text-xl font-thin">Medlemsnr</th>
                  <th className="lg:w-full text-xl font-thin">Navn</th>

                  <th className=" lg:w-5/12 text-xl font-thin">Telefon</th>
                  <th className="lg:w-full text-xl font-thin">Epost</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{year}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>Leder</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Nummer.."
                      name="lederMedlemNummer"
                      ref={register}
                      label="mdlnr"
                      type="text"
                      id="MNR1"
                      className="w-24	lg:w-24 xl:w-7/12"
                      pattern="\d*"
                      maxLength={6}
                    />
                  </td>

                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Navn.."
                      ref={register}
                      name="lederNavn"
                      label="Navn"
                      id="Navn1"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Tlf.."
                      ref={register}
                      name="lederTelefon"
                      label="Telefon"
                      id="Telf1"
                      type="number"
                      className="w-32 lg:w-28 xl:w-28"
                    />
                  </td>
                  <td className="border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="E-post.."
                      ref={register}
                      name="lederEpost"
                      label="E-post"
                      id="Epost1"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                </tr>
                {/*Table two - row two*/}
                <tr>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>{year}</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5 text-xl">
                    <p>Nestleder</p>
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Nummer.."
                      ref={register}
                      name="nestlederMedlemNummer"
                      label="mdlnr"
                      type="text"
                      id="MNR2"
                      className="w-24	lg:w-24 xl:w-7/12"
                      pattern="\d*"
                      maxLength={6}
                    />
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Navn.."
                      ref={register}
                      name="nestlederNavn"
                      label="Navn"
                      id="Navn2"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                  <td className="border-r border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Tlf.."
                      ref={register}
                      name="nestlederTelefon"
                      label="Telefon"
                      id="Telf2"
                      type="number"
                      className="w-32 lg:w-28 xl:w-28"
                    />
                  </td>
                  <td className="border-b border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="E-post.."
                      ref={register}
                      name="nestlederEpost"
                      label="E-post"
                      id="Epost2"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                </tr>
                {/*Table two - third row*/}
                <tr className="">
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>{year}</p>
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5 text-xl">
                    <p>Kasserer</p>
                  </td>
                  <td className="border-r  border-sk-tertiary-blue p-5 text-xl">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Nummer.."
                      ref={register}
                      name="kassererMedlemNummer"
                      label="mdlnr"
                      id="MNR3"
                      type="text"
                      className="w-24	lg:w-24 xl:w-7/12"
                      pattern="\d*"
                      maxLength={6}
                    />
                  </td>
                  <td className="border-r  border-sk-tertiary-blue p-5 text-xl">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Navn.."
                      ref={register}
                      name="kassererNavn"
                      label="Navn"
                      id="Navn3"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                  <td className="border-r border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="Tlf.."
                      ref={register}
                      name="kassererTelefon"
                      label="Telefon"
                      id="Telf3"
                      type="number"
                      className="w-32 lg:w-28 xl:w-28"
                    />
                  </td>
                  <td className="border-sk-tertiary-blue p-5">
                    <Input
                      labelopts={{ labelOn: false, defaultLabelStyle: true }}
                      placeholder="E-post.."
                      ref={register}
                      name="kassererEpost"
                      label="E-post"
                      id="Epost3"
                      flex={true}
                      className="flex flex-grow"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/*This is the go back and forward buttons*/}
        <FooterButtons
          previousLocation="/lokalforening"
          saveOnClick={saveOnClick}
          isSubmitting={isSubmitting}
        />
      </form>
    </div>
  );
};

export default Styret;
